if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        this.elements.viewer.addEventListener('slideChanged', this.onSlideChanged.bind(this));

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
        }
        if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }

        // 绑定所有视频海报封面按钮的点击事件（点击即加载并播放）
        this.elements.viewer.querySelectorAll('deferred-media').forEach((deferred) => {
          const posterBtn = deferred.querySelector('.deferred-media__poster');
          if (posterBtn) {
            posterBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.loadAndPlayVideo(deferred);
            });
          }
        });

        // 首屏 LCP 达成后（延迟 300ms）：首图是视频则自动加载并静音播放
        window.setTimeout(() => {
          const firstSlide = this.elements.viewer.querySelector('.product__media-item.is-active') || this.elements.viewer.querySelector('.product__media-item[data-media-id]');
          if (firstSlide) {
            const firstDeferred = firstSlide.querySelector('deferred-media');
            if (firstDeferred) {
              this.loadAndPlayVideo(firstDeferred);
            }
          }
        }, 300);
      }

      onSlideChanged(event) {
        const currentElement = event.detail.currentElement;
        if (!currentElement) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.remove('is-active');
        });
        currentElement.classList.add('is-active');

        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${currentElement.dataset.mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }

        // 手指滑动切到当前素材：只暂停其他视频，当前视频保持封面+播放按钮，不自动播
        this.manageMediaState(currentElement, false);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail && activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.slider.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          window.scrollTo({ top: activeMediaRect.top + window.scrollY, behavior: 'smooth' });
        });

        // 点击底部缩略图时：直接加载并自动播放（绕过 manageMediaState 直接调 loadAndPlayVideo）
        const deferredMedia = activeMedia.querySelector('deferred-media');
        if (deferredMedia) {
          this.loadAndPlayVideo(deferredMedia);
        } else {
          this.manageMediaState(activeMedia, false);
        }

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      loadAndPlayVideo(deferredMedia) {
        if (!deferredMedia) return;

        // 1. 注入视频模板到 DOM
        if (!deferredMedia.getAttribute('loaded')) {
          const template = deferredMedia.querySelector('template');
          if (template && template.content && template.content.firstElementChild) {
            const content = document.createElement('div');
            content.appendChild(template.content.firstElementChild.cloneNode(true));
            const videoEl = content.querySelector('video, iframe, model-viewer');
            if (videoEl) {
              deferredMedia.appendChild(videoEl);
              deferredMedia.setAttribute('loaded', true);
            }
          }
        }

        // 2. 全局互斥：暂停页面上其他所有视频
        this.elements.viewer.querySelectorAll('video').forEach((v) => {
          if (v !== deferredMedia.querySelector('video')) {
            v.pause();
            const parentDef = v.closest('deferred-media');
            if (parentDef) parentDef.classList.add('is-paused');
          }
        });

        const video = deferredMedia.querySelector('video');
        if (!video) return;

        // 3. 强制静音、循环、内联、无原生控制条
        video.muted = true;
        video.loop = true;
        video.controls = false;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');

        // 4. 绑定点击画面暂停/继续播放
        if (!video.dataset.podClickBound) {
          video.dataset.podClickBound = 'true';
          video.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (video.paused) {
              video.play();
              deferredMedia.classList.remove('is-paused');
            } else {
              video.pause();
              deferredMedia.classList.add('is-paused');
            }
          });
        }

        // 5. 执行播放，处理低电量模式拦截
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              deferredMedia.classList.remove('is-paused');
            })
            .catch(() => {
              deferredMedia.classList.add('is-paused');
            });
        }
      }

      manageMediaState(activeItem, shouldAutoPlay) {
        // 全局互斥：暂停所有非当前视频、YouTube、Vimeo、3D 模型
        document.querySelectorAll('.js-youtube').forEach((v) => {
          if (v.contentWindow) v.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
        document.querySelectorAll('.js-vimeo').forEach((v) => {
          if (v.contentWindow) v.contentWindow.postMessage('{"method":"pause"}', '*');
        });
        document.querySelectorAll('product-model').forEach((m) => {
          if (m.modelViewerUI) m.modelViewerUI.pause();
        });

        this.elements.viewer.querySelectorAll('video').forEach((video) => {
          if (video.closest('.product__media-item') !== activeItem) {
            video.pause();
            const parentDeferred = video.closest('deferred-media');
            if (parentDeferred) parentDeferred.classList.add('is-paused');
          }
        });

        if (shouldAutoPlay) {
          const deferredMedia = activeItem.querySelector('deferred-media');
          if (deferredMedia) this.loadAndPlayVideo(deferredMedia);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
